import { useEffect, useRef, useCallback } from 'react';

interface UseClickOutsideDateTimePickerProps {
  onClickOutside: () => void;
  isOpen: boolean;
}

export const useClickOutsideDateTimePicker = ({
  onClickOutside,
  isOpen,
}: UseClickOutsideDateTimePickerProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      if (
        isOpen &&
        ref.current &&
        !ref.current.contains(event.target as Node) &&
        !document
          .querySelector('.MuiPickersPopper-root')
          ?.contains(event.target as Node) &&
        !document
          .querySelector('.MuiDialog-root')
          ?.contains(event.target as Node)
      ) {
        onClickOutside();
      }
    },
    [isOpen, onClickOutside]
  );

  useEffect(() => {
    if (isOpen) {
      // Add event listener with slight delay to avoid immediate closure
      const timeoutId = setTimeout(() => {
        document.addEventListener('mousedown', handleClickOutside);
      }, 100);

      return () => {
        clearTimeout(timeoutId);
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }

    return () => {}; // Empty cleanup function when not open
  }, [isOpen, handleClickOutside]);

  return ref;
};
